export {default} from './PaginationModel';
export * from './PaginationModel';



// WEBPACK FOOTER //
// ./src/models/PaginationModel/index.ts